module.exports = __webpack_public_path__ + "static/assets/8da171d7703a2e5c191ac63df1f855db.png";